import {
    required,
    minLength,
    maxLength,
    isWithoutEmojis,
    isAmexCard,
    isFutureExpDateDate,
} from 'common/modules/form-validation/validation';
import {
    withMessage,
    combineValidators,
    combineValidationFns,
} from 'common/modules/form-validation';
import { emojiMessage } from 'common/modules/form-validation/validators';
import { CreditCardType } from 'common/api/e-comm/models/CreditCard';

export const nameValidator = combineValidators(
    withMessage('Name on Card is required.')(required),
    withMessage(emojiMessage)(isWithoutEmojis)
);

export const creditCardRegex: Record<CreditCardType, RegExp> = {
    [CreditCardType.Visa]: /^4[0-9]{12}(?:[0-9]{3})?$/,
    [CreditCardType.Mastercard]:
        /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
    [CreditCardType.Discover]:
        /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
};

export const getCreditCardTypeFromNumber = (value: string) => {
    const cardNumber = value.replace(/ /g, '');
    const entry = Object.entries(creditCardRegex).find(([, regex]) => cardNumber.match(regex));
    if (!entry) {
        return null;
    }
    const creditCardType = entry[0] as CreditCardType;
    return creditCardType;
};

const isCardNumberValid = (value: string) => {
    const creditCardType = getCreditCardTypeFromNumber(value);
    return creditCardType != null;
};

export const cardNumberValidator = combineValidators(
    withMessage('Card Number is required.')(required),
    withMessage('We do not accept American Express.')(isAmexCard),
    withMessage('Please enter a valid card number.')(isCardNumberValid)
);

export const cloCardNumberValidator = (value: string) => {
    if (!required(value)) {
        return 'Card Number is required.';
    }
    if (!isCardNumberValid(value)) {
        const creditCardRegexes = Object.values(creditCardRegex);
        const amexRegex = /^3[47][0-9]{13}$/;
        creditCardRegexes.push(amexRegex);

        for (let i = 0; i < creditCardRegexes.length; ++i) {
            if (value.match(creditCardRegexes[i])) {
                return undefined;
            }
        }
        return 'Please enter a valid card number.';
    }
};

export const maskedCardNumberValidator = combineValidators(
    withMessage('Card Number is required.')(required),
    withMessage('We do not accept American Express.')(isAmexCard),
    withMessage('Please enter a valid card number.')(minLength(19)),
    withMessage('Please enter a valid card number.')(isCardNumberValid)
);

export const expirationDateValidator = combineValidators(
    withMessage('Exp. Date is required.')(required),
    withMessage('Please enter a valid Exp. Date: MM/YY.')(minLength(5)),
    withMessage('Please enter a valid Exp. Date: MM/YY.')(isFutureExpDateDate)
);

export const cvcValidator = combineValidators(
    withMessage('CVV is required.')(required),
    withMessage('Please enter a valid 3 digits security code.')(
        combineValidationFns(minLength(3), maxLength(3))
    )
);

export const securityCodeValidator = combineValidators(
    withMessage('CVV is required.')(required),
    withMessage('Invalid CVV.')(combineValidationFns(minLength(3), maxLength(4)))
);

export const amexCardValidator = withMessage('We do not accept American Express.')(isAmexCard);
